import config from '@/config'
import store from '@/store'

import ParticipantInfos from '@/components/mixins/ParticipantInfos'

export default {

  data () {
    return {
      lastScreenId: 'SCREEN0',
      currentStatsIndex: 0,
      rotateStatsTimeoutObj: 0,
      rotateEventsTimeoutObj: 0,
      rotateEventsTimeoutObj1: 0
    }
  },

  mixins: [
    ParticipantInfos
  ],

  computed: {
    appConfigForBrand () {
      return store.getters['cduState/getAppConfigForBrand'] || {}
    },
    cduState () {
      return store.getters['cduState/getScreenState']
    },
    screenConfigurationLoaded () {
      return store.getters['cduState/getScreenConfigurationLoaded']
    },
    screenConfiguration () {
      return store.getters['cduState/getScreenConfiguration']
    },
    maxStatsIndex () {
      return this.cduState === '2column-stats' ? this.cduNonPinnedEventsPaged.length : 0
    },
    maxRotationIndex () {
      return store.getters['bettingOfferState/getMaxRotationIndex']
    },
    maxRotationIndex1 () {
      return store.getters['bettingOfferState/getMaxRotationIndex1']
    },
    currentRotateIndex () {
      return store.getters['bettingOfferState/getCurrentRotateIndex']
    },
    currentRotateIndex1 () {
      return store.getters['bettingOfferState/getCurrentRotateIndex1']
    },
    // This is for big3 with stats screen
    event () {
      return this.cduNonPinnedEventsPaged[this.currentStatsIndex]
    }
  },

  methods: {
    resetCurrentIndex () {
      this.cduSingleEvents.forEach((event, index) => {
        if (event.resetCurrentIndex) {
          switch (index) {
            case 0:
              store.commit('bettingOfferState/setCurrentRotateIndex', 0)
              break

            case 1:
              store.commit('bettingOfferState/setCurrentRotateIndex1', 0)
              break
            default:
          }
        }
      })
    },

    changeRotationIndex (index) {
      let rotateIndex = index || ''
      let maxRotationIndex = `maxRotationIndex${rotateIndex}`
      let currentRotateIndex = `currentRotateIndex${rotateIndex}`
      let setCurrentRotateIndex = `bettingOfferState/setCurrentRotateIndex${rotateIndex}`

      if (this[maxRotationIndex] > 0) {
        if (this[currentRotateIndex] < this[maxRotationIndex]) {
          store.commit(setCurrentRotateIndex, this[currentRotateIndex] + 1)
        } else {
          store.commit(setCurrentRotateIndex, 0)
        }
      } else if (this[currentRotateIndex] !== 0) {
        store.commit(setCurrentRotateIndex, 0)
      }
    },

    rotateEvents () {
      clearTimeout(this.rotateEventsTimeoutObj)
      clearTimeout(this.rotateStatsTimeoutObj)

      // Only in case of 2 column stats, rotate indexes after rotation of stats
      if (this.cduState === '2column-stats' && this.appConfigForBrand.showParticipantStats && this.screenConfiguration.is2showstats) {
        let interval = config.app.statsRotationInterval
        // If live and resulted events stats interval duration needs to be page rotation interval divided with
        if (!this.statsAvailable) {
          interval = config.app.screensRotationInterval / this.cduNonPinnedEventsPaged.length
        }
        this.rotateStatsTimeoutObj = setTimeout(() => {
          // // Skip live and resulted events for showing stats
          // while (lib.betting.event.isLive(this.cduNonPinnedEventsPaged[this.currentStatsIndex]) || lib.betting.event.isResulted(this.cduNonPinnedEventsPaged[this.currentStatsIndex])) {
          //   this.currentStatsIndex++
          // }

          // Rotate
          if (this.currentStatsIndex < this.maxStatsIndex - 1) {
            this.currentStatsIndex++
          } else {
            this.currentStatsIndex = 0
            this.changeRotationIndex()
          }
          this.rotateEvents()
        }, interval)
      } else {
        this.rotateEventsTimeoutObj = setTimeout(() => {
          this.changeRotationIndex()
          this.rotateEvents()
        }, this.screenConfiguration.is2showoutrightevents ? 5000 : config.app.screensRotationInterval)
      }
    },

    rotateEvents1 () {
      clearTimeout(this.rotateEventsTimeoutObj1)

      this.rotateEventsTimeoutObj1 = setTimeout(() => {
        this.changeRotationIndex(1)
        this.rotateEvents1()
      }, this.screenConfiguration.is2showoutrightevents ? 5000 : config.app.screensRotationInterval)
    },

    startRotatingOnScreenChange () {
      if (this.lastScreenId !== this.screenId) {
        this.rotateEvents()
        this.rotateEvents1()
        this.lastScreenId = this.screenId
      }
    }
  },

  mounted () {
    store.commit('bettingOfferState/setCurrentRotateIndex', 0)
    store.commit('bettingOfferState/setCurrentRotateIndex1', 0)
    this.currentStatsIndex = 0
  },

  destroyed () {
    clearInterval(this.rotateEventsTimeoutObj)
    clearInterval(this.rotateEventsTimeoutObj1)
    clearTimeout(this.rotateStatsTimeoutObj)
  },

  watch: {
    screenConfigurationLoaded (newValue, oldValue) {
      if (newValue && !(this.cduState === '2column-stats')) {
        this.startRotatingOnScreenChange()
      }
    },
    screenId () {
      store.commit('bettingOfferState/setCurrentRotateIndex', 0)
      store.commit('bettingOfferState/setCurrentRotateIndex1', 0)
      this.currentStatsIndex = 0
    },
    // This is only for big3 with stats screen as needed data is not loaded (participant info) with screenConfigurationLoaded watch
    cduNonPinnedEventsPaged (newValue, oldValue) {
      if (this.screenConfigurationLoaded && this.cduState === '2column-stats') {
        this.startRotatingOnScreenChange()
      }
    },
    cduSingleEvents () {
      this.resetCurrentIndex()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Rotate.js